// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2Q2Ar","navText":"Navbar_navText__eoZRu","navLogo":"Navbar_navLogo__3KC9Z","imgLogo":"Navbar_imgLogo__2RtmW"};